import { render } from "./RecommendedToday.vue?vue&type=template&id=5d90ac87&scoped=true&ts=true&lang=pug"
import script from "./RecommendedToday.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecommendedToday.vue?vue&type=script&lang=ts&setup=true"

import "./RecommendedToday.vue?vue&type=style&index=0&id=5d90ac87&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d90ac87"]])

export default __exports__